var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadFileIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 376.635,
    height: 263.645,
    viewBox: "0 0 376.635 263.645",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-cloud-upload-alt",
    "data-name": "Icon awesome-cloud-upload-alt",
    d: "M316.373,116.771a56.562,56.562,0,0,0-52.729-76.857,56.207,56.207,0,0,0-31.367,9.534A94.166,94.166,0,0,0,56.5,96.409c0,1.589.059,3.178.118,4.767a84.765,84.765,0,0,0,28.13,164.719H301.308a75.323,75.323,0,0,0,15.065-149.124ZM231.513,152.9H193.025v65.911a9.444,9.444,0,0,1-9.416,9.416H155.362a9.444,9.444,0,0,1-9.416-9.416V152.9H107.459a9.4,9.4,0,0,1-6.65-16.066l62.027-62.027a9.448,9.448,0,0,1,13.3,0l62.027,62.027a9.411,9.411,0,0,1-6.65,16.066Z",
    transform: "translate(0 -2.25)",
    opacity: 0.05
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFileIcon);
export default __webpack_public_path__ + "static/media/uploadFileIcon.4e1568628e6fb52a457cecac2c246cd4.svg";
export { ForwardRef as ReactComponent };